import { render, staticRenderFns } from "./debt-enduser.vue?vue&type=template&id=22564af6&"
import script from "./debt-enduser.vue?vue&type=script&lang=js&"
export * from "./debt-enduser.vue?vue&type=script&lang=js&"
import style0 from "./debt-enduser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports